import React from 'react';
import PropTypes from 'prop-types';
import { useAnalytics } from '../../../../../utils/analytics-provider/analytics-provider';
import { Grid, Cell } from '@carvana/showroom-grid';
import {
  StyledResult,
  StyledLink,
  StyledTextBlock,
  StyledTitle,
  StyledDescription,
  StyledTruncatedContent,
  StyledArrow,
  StyledIconRightCaret
} from './styles';
import { useSupportContext } from '../../../../../helpers/context-provider';
import { SupportCenterParser } from '@carvana/article-renderer/supportcenter';

// TODO: Add Hover State to Row
const Result = ({ article }) => {
  const supportContext = useSupportContext() || {};
  const { title, content, topic, url } = article;
  const { trackEvent } = useAnalytics();
  const updatedArticle = { ...article };
  typeof updatedArticle.topic === 'string' &&
    (updatedArticle.topic = { topic_url: updatedArticle.topic });
  const scp = SupportCenterParser();
  // don't render custom components in results.
  scp.addCustomComponents([
    { name: 'DeliveryOrPickup', component: null },
    { name: 'UsStatesSelect', component: null }
  ]);
  const renderedArticle = article && scp.render(content, supportContext);
  // remove whitespace to show actual text inside limited space.
  if (document) {
    const ele = document.getElementById('cvna-parser');
    if (ele) ele.style.whiteSpace = 'normal';
  }

  return (
    <StyledResult>
      <StyledLink
        to={`/${updatedArticle.topic.topic_url}/${url}`}
        onClick={() => {
          console.log('you clicked an article');
          trackEvent('content_engagement_v2', {
            engagement_type: 'result_link_click',
            link: `/${updatedArticle.topic.topic_url}/${url}`,
            data: updatedArticle
          });
        }}
      >
        <Grid paddingBottom={0} alignItems="center">
          <Cell xs={10}>
            <StyledTextBlock>
              <StyledTitle>{title}</StyledTitle>
              <StyledDescription>
                <StyledTruncatedContent>{renderedArticle}</StyledTruncatedContent>
              </StyledDescription>
            </StyledTextBlock>
          </Cell>
          <Cell xs={2}>
            <StyledArrow>
              <StyledIconRightCaret />
            </StyledArrow>
          </Cell>
        </Grid>
      </StyledLink>
    </StyledResult>
  );
};

Result.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  url: PropTypes.string,
  topic: PropTypes.string
};

export default Result;
